import React, { Component } from 'react';
import './HandHistory.css';
import HandHistoryHeader from './HandHistoryHeader';
import HandCard from './HandCard.js';
import $ from 'jquery';
import i18next from 'i18next';
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import NoHandsAvailable from './NoHandsAvailable';
import { getColor, getTextColor } from '../../common/ThemeService';

class HandHistoryDesktop extends Component {
    render() {
        const themeColor = getColor();
        const themeTextColor = getTextColor();
        return (
            <div className="hand-history-main">
                <style>{`\
                    body{\
                    background-color:white !important;\
                    }\
                    #HH_return-to-top:hover {\
                        background-color: ${themeColor};\
                        color: ${themeTextColor};\
                      }\
                `}</style>
                <div style={{ padding: 0 }} className="container">
                    <HandHistoryHeader
                        showReplayBtn={this.props.showReplayBtn}
                        showMultiReplayer={this.props.showMultiReplayer}
                        setShowFilterModal={this.props.setShowFilterModal}
                        hands={this.props.totalHands} totalProfit={this.props.totalProfit} />
                </div>
                {(!this.props.handList || this.props.handList.length === 0) ? null : <span>
                    <div style={{ padding: 0 }} className="container">
                        <div className="row background-handHistory padding-hand-history-title table-header-handHistory">
                            <div style={{ marginBottom: "0" }} className="table-header-width margin-bottom-0">

                                <div className="row table-header-font">
                                    <div style={{ display: "flex", paddingLeft: 0, paddingRight: 0, marginRight: "-3%" }} className="col-md-2 col-xs-2">
                                        {this.props.isAllHandsSelected !== undefined && this.props.handList.length > 0 &&
                                            <span>
                                                <i onClick={() => {
                                                    this.props.setIsAllHandsSelected()
                                                }}
                                                    data-e2e="checkBox" className={`MyHandsCheckBox fa fa-check ${this.props.isAllHandsSelected ? " MyHandsCheckBoxSelected" : ""}`} aria-hidden="true"></i>
                                            </span>}
                                        <span>{i18next.t("lable.dateAndtime")}</span></div>
                                    <div style={{ padding: "0 0 0 0px" }} className="col-md-2 col-xs-2 HH_holeCards_margin" >{i18next.t("lable.pocketCards")}</div>
                                    <div style={{ padding: "0 0 0 0px", marginRight: "-5.2%", marginLeft: "-4px" }} className="col-md-2 col-xs-2" >{i18next.t("lable.Flop")}</div>
                                    <div style={{ padding: 0, marginRight: "-2.2%" }} className="col-md-1 col-xs-1 HH_turn_padding HH_turnheadingLeftMargin" >{i18next.t("lable.Turn")}</div>
                                    <div style={{ padding: 0 }} className="col-md-1 col-xs-1" >{i18next.t("lable.River")}</div>
                                    <div style={{ padding: 0, marginLeft: "1.6%" }} className="col-md-1 col-xs-1 positionHeadingMargin" >{i18next.t("lable.Position")}</div>
                                    <div style={{ padding: 0 }} className="col-md-1 col-xs-1" >{i18next.t("lable.Profit")}</div>
                                    <div style={{ padding: 0 }} className="col-md-2 col-xs-2 p-0-text-align-right" >&nbsp;&nbsp;&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="border-bottom-hand-history border_full_length"></div>
                </span>}
                <div style={{ padding: 0, marginTop: "3px" }} className="container ">
                    <div id="HH_mainScroll" className="row background-handHistory padding-hand-history">
                        <div style={{ marginBottom: "0" }} className=" table-header-width margin-bottom-0">
                            {this.props.handList.map((hand, index) => {
                                return <HandCard isAllHandsSelected={this.props.isAllHandsSelected}
                                    setShowNoteModal={this.props.setShowNoteModal} openNotes={this.props.openNotes}
                                    key={index} hand={hand} setStarFlagOfHnad={this.props.setStarFlagOfHnad}
                                    selectHand={(hand) => {
                                        this.props.selectHand(hand, index)
                                    }}
                                    unselectHand={(hand) => {
                                        this.props.unselectHand(hand, index)
                                    }}
                                />
                            }
                            )}
                            {!this.props.loading && (!this.props.handList || this.props.handList.length === 0) ?
                                <NoHandsAvailable i18next={i18next} setShowFilterModal={this.props.setShowFilterModal} /> : null
                            }
                            {!this.props.loading && this.props.showMoreFlag && <div className="pagination_wrap" onClick={(e) => {
                                e.preventDefault();
                                this.props.showMoreClicked();
                            }}><div className="MyHands_show_more_button">{i18next.t("lable.showMore")}</div>
                            </div>}
                        </div>
                    </div>
                </div>
                <div>
                    {this.props.showTopButton ? <div id="HH_return-to-top" onClick={() => {
                        $('html').scrollTop(0);
                    }}><i style={{ fontSize: "25px" }} className="fa fa-angle-double-up"></i></div>
                        : null}
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        filter: state.handHistory.filter,
        lang: state.header.lang
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setHandHistoryFilter: (filter) => dispatch(actions.setHandHistoryFilter(filter))
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(HandHistoryDesktop);



/** WEBPACK FOOTER **
 ** ./src/components/HandHistory/HandHistoryDesktop.js
 **/